Promise = require 'bluebird'
assert = require 'lib/assert'
HttpError = require 'network/http-error'
$ = require 'jquery'
xtend = require 'xtend'

module.exports = (args) ->
  assert 'success' !of args && 'error' !of args, "This is promise country!"

  new Promise (resolve, reject) ->
    $.ajax xtend args,
      success: (data) ->
        resolve data
      error: (xhr) ->
        reject HttpError.fromResponse(xhr.status, xhr.responseText)



// WEBPACK FOOTER //
// ./app/scripts/network/ajax-promise.coffee